import {BigInput} from "../../forms/bigInput/BigInput";
import TextAreaNext from "../../forms/textAreaNext/TextAreaNext";
import Checkbox from "../../forms/checkbox/Checkbox";
import Sunglasses from "../../../assets/images/sunglasses.png";
import TimePicker from "../../forms/timePicker/TimePicker";
import WrappedBigPicker from "../../forms/bigPicker/WrappedBigPicker";
import {PRESET_DISTRIBUTION_RATES} from "./preset_distribution_rates";

interface Step3FieldsProps {
    isActive: boolean;
    setIsActive: (newValue: boolean) => void;
    distribution?: number;
    setDistribution?: (newValue: number) => void;
}

const Step3Fields = ({ isActive, setIsActive, distribution, setDistribution }: Step3FieldsProps) => {
    return (
        <>
            <Checkbox
                isSelected={isActive}
                setIsSelected={setIsActive}
                label="Message Activation"
                description="Would you like to activate this message as soon as it's approved?"
            />
            {/*<WrappedBigPicker title="Distribution Percentage" value={distribution} setValue={(newValue) => setDistribution(newValue as number)} options={PRESET_DISTRIBUTION_RATES} description="If you want to test a template's quality before publishing it to all your users, you can set the distribution rate to 5% or 10% and check how it works, you can always increase it as you feel more confident about it." />*/}
        </>
    )
}

export default Step3Fields;